import { myListsEditListFormStyles } from "@insite/content-library/Widgets/MyLists/MyListsEditListForm";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

myListsEditListFormStyles.cancelButton = {
    color: "primary",
    css: css`
        margin-right: 10px;
        border-radius: 25px;
    `,
}

myListsEditListFormStyles.createButton = {
    css: css`
        border-radius: 25px;
    `,
}